<template lang="pug">
.content
  .row
    .col-md-12.member.member-form
      div.box_header
        label.title Chỉnh sửa thành viên
        .clearfix
      div.box-content
        .box-info-member
          .form-group
            label.title-note THÀNH VIÊN CẦN CHỈNH SỬA
          .form-group
            .info-img
              img.img.responsive(:src="require('../../assets/images/faces/ic_AvatarDefault.svg')" v-if="key_avatar === '' || key_avatar === null")
              img.img.responsive(:src="key_avatar" v-else)
            .info-detail
              span.fullname {{key_fullname}}
              span.fa.fa-comment(@click="chatBox")
                abbr Chat ngay
            .clearfix
          .form-group
            label Ngày tham gia đầu tiên:
            span {{key_date_join}}
          .form-group
            label Người duyệt tham gia:
            span {{key_user_approval}}
          .form-group
            label Ngày cập nhật:
            span {{key_date_update}}
          .form-group
            label Người cập nhật:
            span {{key_user_update}}
        .box-public-member
          label.title-note Chọn các Cộng đồng bạn muốn mời các thành viên trên tham gia
          div(v-if="lstPCs !== null && lstPCs.length > 0" v-for="(item, index) in lstPCs")
            templateItem(:item='item' @onClickChecked="onClickChecked" :key="keyIncrement" v-if="item.classes.length > 0")
        .item-pc-bottom
          button.active(@click="saveUserToPC") Lưu thay đổi
          button(@click="cancelRequest") Huỷ yêu cầu
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import templateItem from './templateItemEdit.vue'
import moment from 'moment'
export default {
  components: {
    MdNotification,
    templateItem
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      loader: null,
      lstPCs: [],
      lstJoinPCs: [],
      lstJoinClass: [],
      lstClassesSelected: [],
      lstClassesRemoved: [],
      lstSucess: [],
      lstHistory: [],
      keyIncrement: 0,
      key_user: 0,
      key_avatar: '',
      key_fullname: '',
      key_date_join: '',
      key_user_approval: '',
      key_date_update: '',
      key_user_update: '',
      paramsDefault: this.$route.params,
      userID: this.$store.getters.user
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    onClickChecked(pcID, status, checkedToggle, lstClasses, lstClassesDeleted) {
      if (lstClassesDeleted.length > 0) {
        var classDeleted = lstClassesDeleted[0]
        var retutn = this.lstClassesRemoved.filter(r => r.pc_id === classDeleted.pc_id && r.classes_id === classDeleted.classes_id)
        if (Object.entries(retutn).length === 0) {
          this.lstClassesRemoved.push(classDeleted)
        }
      }
      this.lstClassesSelected = this.lstClassesSelected.filter(item => item.id !== pcID)
      if (lstClasses.length > 0) this.lstClassesSelected.push({id: pcID, status: status, checked: checkedToggle, classes: lstClasses})
    },
    saveUserToPC() {
      var objPCs = this.lstPCs.filter(item => item.checked === true)
      if (Object.entries(objPCs).length === 0) {
        this.showNotification('Vui lòng chọn 1 cộng đồng để tham gia', 'danger', 'top', 'right', 7000)
      } else {
        if (this.lstClassesSelected.length === 0) this.showNotification('Vui lòng chọn lớp muốn tham gia', 'danger', 'top', 'right', 7000)
        else {
          this.lstClassesSelected = this.lstClassesSelected.filter(item => item.checked === true)
          // neu lop khong thay doi va khong xoa lop
          if (this.lstClassesSelected.length === 0 && this.lstClassesRemoved.length > 0) {
            this.show()
            // xu ly xoa thanh vien ra khoi lop va pc
            for (let index = 0; index < this.lstClassesRemoved.length; index++) {
              const item = this.lstClassesRemoved[index]
              if (item.deleted === true && this.key_user !== '') {
                this.deleteUserClassPC(item)
              }
            }
            this.loader.hide()
            this.redirectList()
          } else {
            this.show()
            this.saveData()
          }
        }
      }
    },
    redirectList($messageUpdate = 'Cập nhật dữ liệu thành công', $icon = 'success') {
      this.showNotification($messageUpdate, $icon, 'top', 'right', 7000)
      this.paramsDefault = Object.assign(this.paramsDefault, {reload: 1})
      this.$router.push({name: 'member', params: this.paramsDefault})
    },
    async checkExerciseUserExist($exerciseID, $userID, $classID) {
      var isExists = -1
      var objWhere = {
        exercise_id: {'_eq': $exerciseID},
        user_id: {'eq': $userID},
        class_id: {'_eq': $classID}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.CHECK_EXERCISE_USER_EXIST2),
        fetchPolicy: 'no-cache',
        variables: {
          where: objWhere
        }
      })
      if (data && data.exercise_user.length > 0) {
        // nếu is_delete tai khoan bi xoa
        isExists = data.exercise_user[0].is_delete ? 2 : 1
      } else isExists = 0
      return isExists
    },
    async assignExerciseUser(exerciseIDs, userID, classID, left = false) {
      if (exerciseIDs !== null && exerciseIDs.length > 0) {
        for (let i = 0; i < exerciseIDs.length; i++) {
          var isExists = await this.checkExerciseUserExist(parseInt(exerciseIDs[i]), userID, classID)
          if (!left) {
            if (isExists === 0) {
              let objInput = {
                exercise_id: parseInt(exerciseIDs[i]),
                user_id: userID,
                class_Id: classID,
                created_by: this.$store.getters.user,
                updated_by: this.$store.getters.user
              }
              await this.$apollo.mutate({
                mutation: gql(graphql.CREATE_EXERCISE_USER),
                variables: {object: objInput}
              }).catch((error) => {
                this.loader.hide()
                if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                  this.$router.go(0)
                }
                console.error(error.message)
              })
            } else if (isExists === 2) {
              let objWhere = {
                exercise_id: {_eq: parseInt(exerciseIDs[i])},
                user_id: {_eq: userID},
                class_id: {_eq: classID}
              }
              let objInput = {
                is_delete: false,
                updated_by: this.$store.getters.user
              }
              await this.$apollo.mutate({
                mutation: gql(graphql.UPDATE_EXERCISE_USER),
                variables: {objWhere: objWhere, objInput: objInput}
              }).catch((error) => {
                this.loader.hide()
                if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                  this.$router.go(0)
                }
                console.error(error.message)
              })
            }
          } else {
            if (isExists === 1) {
              let objWhere = {
                exercise_id: {_eq: parseInt(exerciseIDs[i])},
                user_id: {_eq: userID},
                class_id: {_eq: classID}
              }
              let objInput = {
                is_delete: true,
                updated_by: this.$store.getters.user
              }
              await this.$apollo.mutate({
                mutation: gql(graphql.UPDATE_EXERCISE_USER),
                variables: {objWhere: objWhere, objInput: objInput}
              }).catch((error) => {
                this.loader.hide()
                if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                  this.$router.go(0)
                }
                console.error(error.message)
              })
            }
          }
        }
      }
    },
    async deleteUserClassPC(item) {
      var objWhere = {
        pc_id: {_eq: item.pc_id},
        classes_id: {_eq: item.classes_id},
        user_id: {_eq: this.key_user}
      }
      var objInput = {
        is_delete: true,
        updated_by: this.$store.getters.user
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_PC_USER_ALL),
        variables: {objWhere: objWhere, objInput: objInput}
      }).then((res) => {
        // assign bai tap cho user
        this.assignExerciseUser(item.exercise_ids, this.key_user, item.classes_id, true)
      }).catch((error) => {
        console.error(error)
      })
    },
    async saveData() {
      if (this.key_user !== null && this.key_user !== '') {
        try {
          // lay nhung classes_id bi xoa
          for (let index = 0; index < this.lstClassesRemoved.length; index++) {
            const item = this.lstClassesRemoved[index]
            if (item.deleted === true) {
              this.deleteUserClassPC(item)
            }
          }
          // duyet danh sach classes_id da chon
          for (let index = 0; index < this.lstClassesSelected.length; index++) {
            const element = this.lstClassesSelected[index]
            const pcID = Number(element.id)
            const position = Number(element.status)
            await this.saveUserForPC(this.key_user, pcID, position, element.classes)
          }
          this.loader.hide()
          if (this.lstSucess.length > 0) {
            this.redirectList()
          } else {
            this.redirectList('Lỗi cập nhật dữ liệu', 'danger')
          }
        } catch (e) {
          this.loader.hide()
        }
      }
    },
    async saveUserForPC(userID, pcID, position, classes) {
      if (pcID > 0 && position > 0 && classes.length > 0) {
        for (let index = 0; index < classes.length; index++) {
          const classID = classes[index].id
          // const classApproval = Number(classes[index].type_approval)
          // const classPrivate = classes[index].private
          const exerciseIDs = classes[index].exercise_ids
          var variables = {
            pc_id: pcID,
            classes_id: classID,
            user_id: userID,
            status: 2,
            // status: (classApproval === 2 || classPrivate) ? 2 : 1,
            position: position
          }
          var result = await this.getUserJoinPC(pcID, classID, userID)
          if (result === null || result.length === 0) {
            await this.$apollo.mutate({
              mutation: gql(graphql.CREATE_USER_JOIN_TO_PC),
              variables: variables,
              update: (store, { data: { insert_pc_user } }) => {
                if (insert_pc_user.affected_rows) {
                  // assign bai tap cho user
                  this.assignExerciseUser(exerciseIDs, userID, classID)
                  // log history user
                  this.lstSucess.push(userID)
                  var returnHistory = this.lstHistory.filter(h => h.pc_id === pcID && h.user_id === userID)
                  if (Object.entries(returnHistory).length === 0) {
                    this.lstHistory.push({pc_id: pcID, user_id: userID})
                    var returnData = this.lstPCs.filter(o => o.id === pcID)
                    var description = ''
                    if (returnData && returnData.length > 0) {
                      description = returnData[0].name
                    }
                    this.createHistoryPC(pcID, userID, 'CREATE', 'Tham gia vào PC ' + description)
                  }
                }
              }
            }).catch((error) => {
              console.log('error', error)
            })
          } else {
            var objWhere = {
              pc_id: {_eq: Number(pcID)},
              classes_id: {_eq: Number(classID)},
              user_id: {_eq: userID}
            }
            var objInput = {
              // status: (classApproval === 2 || classPrivate) ? 2 : 1,
              position: position,
              is_delete: false,
              updated_by: this.$store.getters.user
            }
            var variablesUpdate = {
              objWhere: objWhere,
              objInput: objInput
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.UPDATE_PC_USER_ALL),
              variables: variablesUpdate,
              update: (store, { data: { update_pc_user } }) => {
                if (update_pc_user.affected_rows) {
                  // assign bai tap cho user
                  this.assignExerciseUser(exerciseIDs, userID, classID)
                  // log history user
                  this.lstSucess.push(userID)
                  var description = ''
                  var returnData = this.lstPCs.filter(o => o.id === pcID)
                  if (returnData && returnData.length > 0) {
                    description = returnData[0].name
                  }
                  if (result && result.length > 0 && position !== result[0].position) {
                    var textPosition = ''
                    textPosition += Number(result[0].position) > 1 ? 'Trợ lý' : 'Học sinh'
                    textPosition += Number(position) > 1 ? ' => Trợ lý' : ' => Học sinh'
                    this.createHistoryPC(pcID, userID, 'POSITION', 'Thay đổi vai trò ' + textPosition + ' trong PC ' + description)
                  }
                  if (result && result.length > 0 && variables.status !== result[0].status) {
                    var textStatus = ''
                    textStatus += Number(result[0].status) > 1 ? 'Đã duyệt' : 'Chờ duyệt'
                    textStatus += Number(variables.status) > 1 ? ' => Đã duyệt' : ' => Chờ duyệt'
                    this.createHistoryPC(pcID, userID, 'POSITION', 'Thay đổi trạng thái duyệt ' + textStatus + ' trong PC ' + description)
                  }
                }
              }
            }).catch((error) => {
              console.log('error', error)
            })
          }
        }
      }
    },
    async getUserJoinPC($pcID, $classID, $userID) {
      var variables = {
        pc_id: $pcID,
        classes_id: $classID,
        user_id: $userID
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.CHECK_USER_JOIN_PC),
        fetchPolicy: 'no-cache',
        variables: variables
      }).catch((error) => {
        console.log('error', error)
      })
      if (data && data.pc_user.length > 0) {
        return data.pc_user
      }
      return null
    },
    cancelRequest() {
      var paramsObject = this.$route.params
      paramsObject = Object.assign(paramsObject, {reload: 1})
      this.$router.push({name: 'member', params: paramsObject})
    },
    chatBox() {
      this.showNotification(this.message, 'warning', 'top', 'right', 2000)
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    fmDate(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm')
    },
    infoUserEdit(variables) {
      const {data} = this.$apollo.query({
        query: gql(graphql.GET_USER_JOIN_FIRST_LAST),
        fetchPolicy: 'no-cache',
        variables() {
          return variables
        }
      })
      return data.pc_user
    },
    increment() {
      this.keyIncrement++
    },
    addMinutes(dt, minutes) {
      var now = new Date(dt.getTime() + minutes * 60000)
      return (now.getFullYear() + '-' + (((now.getMonth() + 1) < 10) ? ('0' + (now.getMonth() + 1)) : ((now.getMonth() + 1))) + '-' + (now.getDate()) + ' ' + now.getHours() + ':' + ((now.getMinutes() < 10) ? ('0' + now.getMinutes()) : (now.getMinutes())) + ':' + ((now.getSeconds() < 10) ? ('0' + now.getSeconds()) : (now.getSeconds())))
    },
    async createHistoryPC(pcID, userID, action, description) {
      var objInput = {
        pc_id: pcID,
        user_id: userID,
        action: action,
        name: 'TEACHER',
        description: description,
        access_time: this.addMinutes(new Date(), 10)
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.CREATE_PC_HISTORY),
        variables: {objInput: objInput}
      })
    }
  },
  beforeDestroy() {
  },
  mounted () {
    this.increment()
  },
  async created () {
    if (this.paramsDefault && this.paramsDefault.user_id !== undefined && this.paramsDefault.user_id !== '') {
      this.key_user = this.paramsDefault.user_id
      var variables = {
        user_id: this.key_user,
        order_by: {created_at: 'asc'}
      }
      await this.$apollo.query({
        query: gql(graphql.GET_USER_JOIN_FIRST_LAST),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((respon) => {
        if (respon.data.pc_user && respon.data.pc_user.length > 0) {
          var item = respon.data.pc_user[0]
          this.key_date_join = this.fmDate(item.created_at)
          this.key_avatar = item.user.avatar
          this.key_fullname = item.user.fullname
          if (item.userApproval !== null) {
            this.key_user_approval = item.userApproval.fullname
          }
        }
      })
      var variablesUpdate = {
        user_id: this.key_user,
        order_by: {updated_at: 'desc'}
      }
      await this.$apollo.query({
        query: gql(graphql.GET_USER_JOIN_FIRST_LAST),
        fetchPolicy: 'no-cache',
        variables: variablesUpdate
      }).then((respon) => {
        if (respon.data.pc_user && respon.data.pc_user.length > 0) {
          var item = respon.data.pc_user[0]
          this.key_date_update = this.fmDate(item.updated_at)
          if (item.userUpdated !== null) {
            this.key_user_update = item.userUpdated.fullname
          }
        }
      })
      if (this.paramsDefault.pc_id > 0) {
        await this.$apollo.query({
          query: gql(graphql.GET_USER_JOIN_PC),
          fetchPolicy: 'no-cache',
          variables: {
            user_id: this.key_user
          }
        }).then((respon) => {
          if (respon.data.pc_user && respon.data.pc_user.length > 0 && this.lstPCs.length > 0) {
            var pcUsers = respon.data.pc_user
            for (let index = 0; index < this.lstPCs.length; index++) {
              const item = this.lstPCs[index]
              var objPCs = pcUsers.filter(a => a.pc_id === item.id)
              this.lstPCs[index].checked = Object.entries(objPCs).length > 0
              if (item.classes !== undefined && item.classes !== null && item.classes.length > 0) {
                var lstClassNormal = []
                for (let index1 = 0; index1 < item.classes.length; index1++) {
                  const element = item.classes[index1]
                  var objClasses = pcUsers.filter(a => a.pc_id === item.id && a.classes_id === element.id)
                  this.lstPCs[index].classes[index1].checked = Object.entries(objClasses).length > 0
                  var position = Object.entries(objClasses).length > 0 ? Number(objClasses[0].position) : 1
                  var lstClasses = {id: element.id, private: element.private, type_approval: element.type_approval, exercise_ids: element.exercise_ids}
                  if (Object.entries(objClasses).length > 0) lstClassNormal.push(lstClasses)
                }
                this.lstClassesSelected.push({id: item.id, status: position, checked: true, classes: lstClassNormal})
              }
            }
          }
        })
      }
      this.increment()
    } else {
      this.$router.push({name: 'member'})
    }
  },
  apollo: {
    lstPCs: {
      query: gql(graphql.GET_USER_JOIN_PC_MEMBER),
      variables() {
        return {
          user_id: this.$store.getters.user,
          order_by: {updated_at: 'desc', name: 'asc'}
        }
      },
      update: data => {
        return data.private_community
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box_header{
  .title{text-align: left; font-size: 20px; font-weight: bold; letter-spacing: 0px;color: #5F6468;}
}
.member-form{
  .box-content{margin-top: 15px;
    .form-group{padding: 0; margin: 0;
      label{font-weight: normal;}
    }
    .box-info-member{margin-bottom: 15px;
      .form-group{ margin-bottom: 10px;
        label{letter-spacing: 0px; color: #5F6468; font-size: 15px; font-weight: bold;
          &.title-note{color: #9F6A28;text-transform: uppercase; font-weight: bold !important; font-size: 15px;margin-bottom: 8px;}
        }
        span{color: #333333; font-size: 15px; margin-left: 10px;}
        .info-img{ width: 48px; height: 48px; border-radius: 50%; overflow: hidden; position: relative; display: inline-flex; float: left;
          img{max-width: 100%; height: auto;margin: 0 auto;}
        }
        .info-detail{width: calc(100% - 60px); margin-left: 8px; float: left;
          span{display: block; margin: 0; text-align: left;
            &.fullname{color: #333333; font-size: 15px; margin-bottom: 4px;}
            &.fa-comment{color: #219AFF; cursor: pointer;}
            abbr{margin-left: 8px;}
          }
        }
      }
    }
    
    .box-public-member{
      .title-note{color: #9F6A28;text-transform: uppercase; font-weight: bold !important; font-size: 15px;margin-bottom: 16px;}
      .item-public-member{padding: 15px; border-radius: 10px; background: #fff; margin-bottom: 16px;
        .item-checkbox{display:inline-flex; width: 30px;justify-content: center;align-items: center;
          input{display:none;}
          input + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box_outline@2x.png") no-repeat center center;height: 20px;width: 20px;display:inline-block; background-size: cover; margin: 0;}
          input:checked + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box@2x.png") no-repeat center center;height: 20px;width: 20px;display:inline-block;background-size: cover;}
        }
        .item-top-board{display: flex;justify-content: center; align-items: center; margin-bottom: 10px;
          .board-img{width: 16px; height: 16px; margin: 0 auto; border-radius: 50%; display: inline-flex;overflow: hidden; justify-content: center;
            img{max-width: 100%; height: auto; object-fit: cover;}
          }
          .board-info{ width: calc(100% - 200px); display: inline-flex; margin-left: 8px;
            span{font-size: 15px; font-weight: bold; display: block;}
          }
          .borard-check{display: inline-flex; width: 170px;
            span {color: #333333; font-size: 15px;}
          }
        }
      }
    }
    .item-pc-bottom{
      button{margin: 0; height: 48px; width: 120px; border: 0 none; border-radius: 5px; font-size: 14px; display: inline-block; color: #23180A;
        &.active{background: #FFD311 0% 0% no-repeat padding-box;margin-right: 30px;}
      }
    }
  }
}
@media (max-width: 1366px){
  
}
@media (max-width: 1024px){
  
}
@media (max-width: 991px){
}
@media (max-width: 767px){
  
}
@media (max-width: 560px){
 
}
</style>



// WEBPACK FOOTER //
// edit.vue?14d57d51